<app-help-page mainVideo="notification-destinations"
               [tutorials]="['notification-destinations', 'notification-destination-slack', 'notification-destination-teams', 'notification-destination-google-chat']"
               [videos]="['notification-destinations']"></app-help-page>
